import { makeInflect } from "../utils/makeInflect.js";

export const inflectFillingsLeft = makeInflect("náplň", "náplně", "náplní");
